import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "sliceMsg",
  standalone: true,
})
export class SliceMsgPipe implements PipeTransform {
  transform(value: string): string {
    return value?.length > 30 ? value.slice(0, 30) + "..." : value;
  }
}
